import { render, staticRenderFns } from "./event-big-calendar.vue?vue&type=template&id=8aee5632&"
import script from "./event-big-calendar.vue?vue&type=script&lang=js&"
export * from "./event-big-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports